"use client";

import { useEffect } from "react";

/**
 * Updates `<html lang>` to match the current locale segment. Root
 * layout bakes a default `lang="az"` into the SSR'd HTML (Next 15
 * requires html/body in the root, but the root can't see URL params)
 * - this client effect bumps the attribute once the [locale] layout
 * mounts so screen readers and Chrome's translation banner pick up
 * the right language.
 */
export default function HtmlLangEffect({ locale }: { locale: string }) {
  useEffect(() => {
    if (document.documentElement.lang !== locale) {
      document.documentElement.lang = locale;
    }
  }, [locale]);
  return null;
}
